export default "__VITE_ASSET__DsGXwi8y__"